"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.statistics.title': 'Statistiche dei tutorial',
    'tutorial.statistics.details': 'Partecipanti e progressi del tutorial',
    'tutorial.statistics.subtitle': 'Seleziona un tutorial per vedere i progressi dei partecipanti.',
    'tutorial.statistics.tutorial': 'Tutorial',
    'tutorial.statistics.category': 'Categoria',
    'tutorial.statistics.actions': 'Azioni',
    'tutorial.statistics.viewParticipants': 'Vedi partecipanti',
    'tutorial.statistics.search': 'Cerca',
    'tutorial.statistics.retry': 'Riprova',
    'tutorial.statistics.refresh': 'Aggiorna',
    'tutorial.statistics.back': 'Torna ai tutorial',
    'tutorial.statistics.pagination': 'Pagine dei tutorial',
    'tutorial.statistics.previous': 'Precedente',
    'tutorial.statistics.next': 'Successiva',
    'tutorial.statistics.participants': 'Partecipanti',
    'tutorial.statistics.participant': 'Partecipante',
    'tutorial.statistics.identity': 'Tipo di partecipante',
    'tutorial.statistics.registered': 'Utente registrato',
    'tutorial.statistics.guest': 'Ospite',
    'tutorial.statistics.currentStep': 'Ultimo passaggio salvato',
    'tutorial.statistics.currentSection': 'Ultima sezione salvata',
    'tutorial.statistics.tasks': 'Attività completate',
    'tutorial.statistics.progress': 'Progresso',
    'tutorial.statistics.progressExplanation': 'Il progresso è la percentuale di attività del tutorial completate da ogni partecipante. La posizione salvata non indica il completamento.',
    'tutorial.statistics.notStarted': 'Nessuna posizione salvata',
    'tutorial.statistics.noTasks': 'Nessuna attività',
    'tutorial.statistics.emptyTutorials': 'Nessun tutorial trovato.',
    'tutorial.statistics.emptyParticipants': 'Questo tutorial non ha ancora partecipanti.',
    'tutorial.statistics.loadFailed': 'Impossibile caricare le statistiche del tutorial.',
    'tutorial.statistics.time_data': 'Dati temporali del partecipante al tutorial',
    'tutorial.statistics.viewTimeData': 'Visualizza dati temporali',
    'tutorial.statistics.time': 'Tempo nella sezione',
};
